<template>
  <div class="dataset-share-view-container">
    <div class="header-box">
      <p class="dataset-name">{{ dataSetInfo.dataSetName }}</p>
      <QrcodeTooltip
        shareType="dataSet"
        :linkUrl="linkUrl" />
    </div>
    <div class="content-box">
      <div
        class="catalog-tree-btn-box"
        v-if="isVectorView() && mainSceLoaded"
        @click="openVectorAttrPanel">
        <icon-svg
          size="26"
          class="icon"
          icon-class="ic-shuxing1" />
      </div>
      <div
        class="catalog-tree-btn-box"
        v-if="canvasViewMode !== 'cad' && isCadToolBarVisible()"
        @click="openViewTreePanel">
        <icon-svg
          size="20"
          class="icon"
          icon-class="ic-mulushu1" />
      </div>
      <div
        :class="`cad-toolbar-box 
        ${canvasViewMode === 'bimCad' ? 'left50' : 'left0'}
        ${
          canvasViewMode !== 'cad' && canvasViewMode !== 'bimCad'
            ? 'margin30'
            : ''
        }`"
        v-if="isCadToolBarVisible()">
        <div class="svg-box">
          <icon-svg
            size="20"
            title="图层"
            icon-class="ic-tuceng"
            class="icon"
            @click.native="openCadLayerPanel" />
        </div>
        <div class="svg-box">
          <icon-svg
            size="20"
            title="布局"
            icon-class="icon-buju"
            class="icon"
            @click.native="openCadLayoutPanel" />
        </div>
        <div
          class="svg-box"
          v-if="canvasViewMode !== 'cad'">
          <icon-svg
            title="切换视图"
            icon-class="ic-qiehuan"
            class="icon"
            @click.native="toggleCanvasViewMode" />
        </div>
      </div>
      <Engine
        ref="engineDemo"
        :onUIThemeChange="onUIThemeChange"
        :modelClick="handleModelClick"
        :loadMainScene="loadMainScene"
        :onMainSceLoaded="onMainSceLoaded"
        :onCadLoadFinish="onCadLoadFinish"
        :handleCadElemClick="handleCadElemClick"
        :togglePanelVisible="togglePanelVisible"
        :vectorClick="handleVectorClick" />
      <dataSetTreePanel
        ref="viewTree"
        v-show="viewTreePanelVisible"
        :limitDragArea="viewTreePanelLimit"
        :closePanel="closeViewTreePanel"
        :updateAttributeType="updateAttributeType"
        :updateAttributeData="updateAttributeData"
        :loadBIMCAD="loadBIMCAD"
        :resetElemAttr="resetElemAttr"
        :showRoom="showRoom"
        :highLightElement="highLightElement"
        :hiddenDataset="hiddenDataset"
        :showDataset="showDataset"
        :hiddenElement="hiddenElement"
        :showElement="showElement"
        :setCanvasViewMode="setCanvasViewMode"
        :closeCadLayerPanel="closeCadLayerPanel"
        :closeCadLayoutPanel="closeCadLayoutPanel" />
      <attributePanel
        v-show="attributePanelVisible"
        :isRvtGroupMode="isRvtGroupMode"
        :isElemExist="isElemExist"
        :attributeData="attributeData"
        :closePanel="closeAttributePanel" />
      <texturePanel
        v-if="texturePanelVisible"
        type="DataSet"
        :modelInfo="modelInfo"
        :closePanel="closeTexturePanel" />
      <CadLayerPanel
        ref="cadLayer"
        v-if="cadlayerPanelVisible && cadLoadFinish"
        :limitDragArea="cadLayerPanelLimit"
        :closePanel="closeCadLayerPanel" />
      <CadLayoutPanel
        ref="cadLayout"
        v-if="cadLayoutPanelVisible && cadLoadFinish"
        :cadInfo="rvtCadInfo"
        :limitDragArea="cadLayerPanelLimit"
        :closePanel="closeCadLayoutPanel" />
      <VectorAttrPanel
        v-if="isVectorAttrPanelVisible"
        :vectorAttrData="vectorAttrData"
        :closePanel="closeVectorAttrPanel" />
    </div>
  </div>
</template>

<script>
import dataSetTreePanel from './components/DataSetTreePanel.vue'
import texturePanel from './components/TexturePanel.vue'
import attributePanel from '@/components/AttributePanel.vue'
import Engine from './components/DataSetShareViewEngine.vue'
import CadLayerPanel from '../singleProject/dataManage/components/CadLayerPanel.vue'
import CadLayoutPanel from '../singleProject/dataManage/components/CadLayoutPanel.vue'
import VectorAttrPanel from '../singleProject/dataManage/components/VectorAttrPanel.vue'
import QrcodeTooltip from './components/QrcodeTooltip.vue'

import { isMobileDevice } from '@/utils/generalMethods'
import { highLightElems } from '@/utils/engineUtils'

import {
  shareRead,
  getSharedProjectTree,
  getSharedCadDatasetFiles,
  getSharedProjectModel,
  getSharedProjectParam,
  getSharedTextureList,
  getSharedElemIdByCadId,
  getSharedCadIdByElemId,
  getSharedVectorParam
} from '@/service/interface'

import {
  getSharedRvtGroupByElemIdService,
  getSharedRvtGroupAttrService,
  getSharedBimElemIdsByGroupService
} from '@/service/share/sceneShareInterface.js'

const dataSetTypeNameMap = {
  0: 'Bim',
  10: 'Wmts',
  11: 'Osgb',
  13: 'Rs',
  14: 'Panorama',
  15: 'PointCloud',
  16: 'Cad',
  20: 'Vector'
}
export default {
  data() {
    return {
      dataSetInfo: {},
      modelInfo: [],
      mainSceLoaded: false,

      viewTreePanelVisible: false,

      isRvtGroupMode: false,
      elementId: '',
      attributePanelVisible: false,
      attributeType: 'element',
      attributeData: [],

      texturePanelVisible: false,

      // canvas显示模式
      // model: 单个数据集
      // bimCad: BIM-CAD分屏展示
      // rvtCad: 带二维图纸的rvt模型单独展示二维图纸
      // cad: 二维图纸正常展示
      canvasViewMode: 'model',
      rvtCadInfo: {},

      cadLoadFinish: false,
      viewTreePanelLimit: '',
      cadLayerPanelLimit: 'right',
      cadlayerPanelVisible: false,

      cadLayoutPanelVisible: false,

      isVectorAttrPanelVisible: false,
      vectorAttrData: [],

      linkUrl: ''
    }
  },
  computed: {
    isElemExist() {
      return this.elementId ? true : false
    }
  },
  components: {
    dataSetTreePanel,
    attributePanel,
    Engine,
    texturePanel,
    CadLayerPanel,
    CadLayoutPanel,
    VectorAttrPanel,
    QrcodeTooltip
  },
  created() {
    this.initDataSetInfo().then(() => {
      this.recordShareRead()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$refs.engineDemo.resetViewMode()

    this.deleteCustomBtn('Attribute')
    this.deleteCustomBtn('Catalog_Tree')
    this.deleteCustomBtn('Texture')
    window.BlackHole3D.Clip.endClip()
    this.copyCanvas()
    next()
  },
  methods: {
    initDataSetInfo() {
      return new Promise(resolve => {
        let resourceId = this.$route.params.resourceId
        let params = { dataSetId: resourceId }
        let headers = this.getHeaders()
        getSharedProjectTree(params, { headers }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            this.dataSetInfo = data[0]

            let { origin, pathname } = window.location
            let { shareId, resourceId } = this.$route.params
            let { dataType, token } = this.$route.query

            let linkUrl = `${origin}${pathname}#/dataSetShare/view/${shareId}/${resourceId}?dataType=${dataType}&token=${token}`
            this.linkUrl = linkUrl

            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    loadMainScene() {
      let dataSetType = this.dataSetInfo.dataSetType
      let dataType = dataSetTypeNameMap[dataSetType]
      if (dataType === 'Cad') {
        this.canvasViewMode = 'cad'
        this.viewTreePanelLimit = ''
        this.cadLayerPanelLimit = ''
        this.getCadData().then(cadData => {
          let cadInfo = cadData[0]
          let fileName = cadInfo.fileName
          cadInfo.name = fileName.substring(0, fileName.lastIndexOf('.'))
          this.rvtCadInfo = cadInfo
          this.$refs.engineDemo.loadDataSet(dataType, cadInfo)
        })
      }
      if (dataType !== 'Cad') {
        this.getDatasetResource().then(() => {
          this.$refs.engineDemo.loadDataSet(dataType, this.modelInfo)
        })
      }
    },
    onMainSceLoaded() {
      this.mainSceLoaded = true
      let dataSetType = this.dataSetInfo.dataSetType
      let dataType = dataSetTypeNameMap[dataSetType]
      if (dataType === 'Vector') {
        window.BlackHole3D.Graphics.setSysUIPanelVisible(false)
        window.BlackHole3D.Graphics.setGeoCoordVisible(false)
      }
      if (dataType === 'Bim') {
        let domRef = this.$refs.engineDemo

        // 添加目录树按钮
        let treeLightImg = this.getImgPath('treeLight.png')
        let treeLightCheckImg = this.getImgPath('treeLightCheck.png')
        let treeStateList = []
        treeStateList.push({ hintText: '目录树', texPath: treeLightImg })
        treeStateList.push({ hintText: '目录树', texPath: treeLightCheckImg })
        if (!isMobileDevice()) {
          this.viewTreePanelVisible = true
          domRef.addCustomBtn('Catalog_Tree', treeStateList, 1)
        } else {
          this.viewTreePanelVisible = false
          domRef.addCustomBtn('Catalog_Tree', treeStateList, 0)
        }

        // 添加属性按钮
        let attrLightImg = this.getImgPath('attrLight.png')
        let attrLightCheckImg = this.getImgPath('attrLightCheck.png')
        let attrStateList = []
        attrStateList.push({ hintText: '属性', texPath: attrLightImg })
        attrStateList.push({ hintText: '属性', texPath: attrLightCheckImg })
        domRef.addCustomBtn('Attribute', attrStateList, 0)

        // 添加纹理动画按钮
        let texLightImg = this.getImgPath('texLight.png')
        let texLightCheckImg = this.getImgPath('texLightCheck.png')
        let texStateList = []
        texStateList.push({ hintText: '纹理动画', texPath: texLightImg })
        texStateList.push({
          hintText: '纹理动画',
          texPath: texLightCheckImg
        })
        domRef.addCustomBtn('Texture', texStateList, 0)

        this.renderTexture()
      }
    },
    renderTexture() {
      let dataSetId = this.$route.params.resourceId
      let params = { dataSetId }
      let headers = this.getHeaders()
      getSharedTextureList(params, { headers }).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let textureList = data.filter(el => el.isApplied && !el.removeStatus)
          if (textureList.length) {
            let BlackHole3D = window.BlackHole3D
            let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
            let resId = find.resId
            textureList.forEach(item => {
              let anim = new BlackHole3D.REElemUVAnim()
              anim.dataSetId = resId
              anim.elemIdList = item.elements
              let scale = Number((1 / item.compressionRatio).toFixed(2))
              anim.scale = [scale, 1]
              let speed = item.direction > 0 ? item.flowRate : -item.flowRate
              anim.speed = [speed, 0]

              BlackHole3D.BIM.setElemUVAnimAttr(anim)
            })
          }
        }
      })
    },
    onCadLoadFinish() {
      this.cadLoadFinish = true

      if (this.canvasViewMode === 'bimCad') {
        this.updateAttributeType('')
        this.updateCadLayer()
        this.updateCadLayout()
        this.viewTreePanelLimit = 'left'
        this.cadLayerPanelLimit = 'right'
      } else {
        this.viewTreePanelLimit = ''
        this.cadLayerPanelLimit = ''
      }
    },
    isCadToolBarVisible() {
      let visible = false
      let canvasViewMode = this.canvasViewMode
      let cadLoadFinish = this.cadLoadFinish
      if (cadLoadFinish && canvasViewMode.toLowerCase().includes('cad')) {
        visible = true
      } else {
        visible = false
      }
      return visible
    },
    getCadData() {
      return new Promise(resolve => {
        let resourceId = this.$route.params.resourceId
        let params = { dataSetId: resourceId }
        let headers = this.getHeaders()
        getSharedCadDatasetFiles(params, { headers }).then(response => {
          if (response.isSuccess) {
            let cadData = response.data.items
            resolve(cadData)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    getDatasetResource() {
      return new Promise(resolve => {
        let resourceId = this.$route.params.resourceId
        let dataSetIds = [resourceId]
        let params = { dataSetIds }
        let token = this.$route.query.token
        let headers = { Authorization: token }
        getSharedProjectModel(params, { headers }).then(response => {
          if (response.isSuccess) {
            let dataSets = response.data
            this.modelInfo = dataSets
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    onUIThemeChange(theme) {
      let Graphics = window.BlackHole3D.Graphics
      if (theme.includes('Light')) {
        let treeLightImg = this.getImgPath('treeLight.png')
        let treeLightCheckImg = this.getImgPath('treeLightCheck.png')
        Graphics.setBtnStatePicPath('Catalog_Tree', 0, treeLightImg)
        Graphics.setBtnStatePicPath('Catalog_Tree', 1, treeLightCheckImg)
        Graphics.setSysPanelBtnClrStyle('Catalog_Tree', 0)

        let attrLightImg = this.getImgPath('attrLight.png')
        let attrLightCheckImg = this.getImgPath('attrLightCheck.png')
        Graphics.setBtnStatePicPath('Attribute', 0, attrLightImg)
        Graphics.setBtnStatePicPath('Attribute', 1, attrLightCheckImg)
        Graphics.setSysPanelBtnClrStyle('Attribute', 0)

        let texLightImg = this.getImgPath('texLight.png')
        let texLightCheckImg = this.getImgPath('texLightCheck.png')
        Graphics.setBtnStatePicPath('Texture', 0, texLightImg)
        Graphics.setBtnStatePicPath('Texture', 1, texLightCheckImg)
        Graphics.setSysPanelBtnClrStyle('Texture', 0)
      }

      if (theme.includes('Dark')) {
        let treeDarkImg = this.getImgPath('treeDark.png')
        let treeDarkCheckImg = this.getImgPath('treeDarkCheck.png')
        Graphics.setBtnStatePicPath('Catalog_Tree', 0, treeDarkImg)
        Graphics.setBtnStatePicPath('Catalog_Tree', 1, treeDarkCheckImg)
        Graphics.setSysPanelBtnClrStyle('Catalog_Tree', 1)

        let attrDarkImg = this.getImgPath('attrDark.png')
        let attrDarkCheckImg = this.getImgPath('attrDarkCheck.png')
        Graphics.setBtnStatePicPath('Attribute', 0, attrDarkImg)
        Graphics.setBtnStatePicPath('Attribute', 1, attrDarkCheckImg)
        Graphics.setSysPanelBtnClrStyle('Attribute', 1)

        let texDarkImg = this.getImgPath('texDark.png')
        let texDarkCheckImg = this.getImgPath('texDarkCheck.png')
        Graphics.setBtnStatePicPath('Texture', 0, texDarkImg)
        Graphics.setBtnStatePicPath('Texture', 1, texDarkCheckImg)
        Graphics.setSysPanelBtnClrStyle('Texture', 0)
      }
    },
    async handleModelClick(info) {
      let elemIds = window.BlackHole3D.BIM.getSelElemIDs()
      if (!elemIds.length || info.elemType !== 'BIMElem') {
        this.elementId = ''
        this.attributeData = []
        return
      }

      let elementInfo = JSON.parse(JSON.stringify(info))
      let elementId = elementInfo.elemId
      this.elementId = elementId
      if (this.canvasViewMode === 'bimCad') {
        this.queryCadElem(elementId)
      }

      // 如果以分组组织目录树，点击构件时，需要高亮构件所在分组的所有构件
      const isShowRvtGroup = this.$refs.viewTree?.isShowRvtGroup
      this.isRvtGroupMode = isShowRvtGroup ? true : false
      if (isShowRvtGroup) {
        const rvtGroupInfo = await this.getRvtGroupInfo()
        this.highLightGroupElems(rvtGroupInfo)

        if (this.attributePanelVisible) {
          const attributeData = await this.getRvtGroupAttr(rvtGroupInfo)
          this.attributeData = attributeData
        }
      } else {
        if (this.attributePanelVisible) {
          this.queryElementAttr()
        }
      }
    },
    async getRvtGroupInfo() {
      const dataSetId = this.$route.params.resourceId
      const token = this.$route.query.token
      const headers = { Authorization: token }
      const params = { dataSetId, elemIntId: this.elementId }
      const response = await getSharedRvtGroupByElemIdService(params, headers)
      if (response.isSuccess) {
        return response.data
      } else {
        this.$message.error(response.errMsg)
      }
    },
    async queryElementAttr() {
      let resourceId = this.$route.params.resourceId
      let token = this.$route.query.token
      let headers = { Authorization: token }
      let params = {
        dataSetId: resourceId,
        elementIntId: this.elementId,
        isQueryExtend: false
      }
      getSharedProjectParam(params, { headers }).then(response => {
        if (response.isSuccess) {
          let data = response.data
          this.attributeData = data.elementParamGroups
        } else {
          this.attributeData = []
        }
      })
    },
    async getRvtGroupAttr(rvtGroupInfo) {
      if (!rvtGroupInfo) {
        return []
      }

      const dataSetId = this.$route.params.resourceId
      const token = this.$route.query.token
      const headers = { Authorization: token }
      const groupIntId = rvtGroupInfo.groupIntId
      const params = { dataSetId, groupIntId }
      // prettier-ignore
      const response = await getSharedRvtGroupAttrService(params, headers)
      if (response.isSuccess) {
        const data = response.data
        return data.params
      } else {
        this.$message.error(response.errMsg)
        return []
      }
    },
    async highLightGroupElems(rvtGroupInfo) {
      if (!rvtGroupInfo) return

      const dataSetId = this.$route.params.resourceId
      const token = this.$route.query.token
      const headers = { Authorization: token }
      const groupIntId = rvtGroupInfo.groupIntId
      const hostFileId = rvtGroupInfo.hostFileId
      const params = {
        dataSetId,
        hostFileId: String(hostFileId),
        childNodeId: [groupIntId]
      }
      const response = await getSharedBimElemIdsByGroupService(params, headers)
      if (response.isSuccess) {
        const data = response.data
        const resId = dataSetId.replaceAll('-', '')
        const elemIds = data.childNodeIds.length
          ? data.childNodeIds
          : [this.elementId]
        highLightElems(resId, elemIds, false)
      } else {
        this.$message.error(response.errMsg)
      }
    },
    queryCadElem(elementId) {
      let dataSetId = this.$route.params.resourceId
      let hostFileId = this.rvtCadInfo.hostFileId
      let params = {
        dataSetId,
        hostFileId,
        elementIntId: elementId
      }
      let headers = this.getHeaders()
      getSharedCadIdByElemId(params, { headers }).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let cadElemInfo = data[0]
          let cadElemId = cadElemInfo.cadHandleId
          this.$refs.engineDemo.heightCADElement(cadElemId)
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    handleCadElemClick(cadElemId) {
      let dataSetType = this.dataSetInfo.dataSetType
      let dataType = dataSetTypeNameMap[dataSetType]
      if (dataType !== 'Bim') return

      let dataSetId = this.$route.params.resourceId
      let hostFileId = this.rvtCadInfo.hostFileId
      let cadSheetId = this.rvtCadInfo.cadSheetId
      let params = {
        dataSetId,
        hostFileId,
        cadSheetId,
        cadHandleId: cadElemId
      }
      let headers = this.getHeaders()
      getSharedElemIdByCadId(params, { headers }).then(response => {
        if (response.isSuccess) {
          let elemId = response.data
          this.highLightElement([elemId])
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    isVectorView() {
      let dataSetType = this.dataSetInfo.dataSetType
      let dataType = dataSetTypeNameMap[dataSetType]
      if (dataType === 'Vector') {
        return true
      } else {
        return false
      }
    },
    handleVectorClick(elemId) {
      let dataSetType = this.dataSetInfo.dataSetType
      let dataType = dataSetTypeNameMap[dataSetType]
      if (dataType !== 'Vector') return

      let dataSetId = this.$route.params.resourceId
      let params = { dataSetId, elemId }
      let headers = this.getHeaders()
      getSharedVectorParam(params, { headers }).then(response => {
        if (response.isSuccess) {
          let vectorAttrData = response.data
          this.vectorAttrData = vectorAttrData
          this.isVectorAttrPanelVisible = true
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    openVectorAttrPanel() {
      this.isVectorAttrPanelVisible = true
    },
    closeVectorAttrPanel() {
      this.isVectorAttrPanelVisible = false
    },
    updateAttributeType(attributeType) {
      this.attributeType = attributeType
      this.closeAttributePanel()
    },
    updateAttributeData(data) {
      this.attributeData = data
    },
    async togglePanelVisible(btnName) {
      let Graphics = window.BlackHole3D.Graphics
      let btnStatus = Graphics.getBtnActiveState(btnName)
      if (btnName.includes('Catalog_Tree')) {
        if (btnStatus === 1) {
          this.viewTreePanelVisible = true
        } else {
          this.viewTreePanelVisible = false
        }
      }

      if (btnName.includes('Attribute')) {
        if (btnStatus === 1) {
          this.attributePanelVisible = true
          this.texturePanelVisible = false
          window.BlackHole3D.Graphics.setBtnActiveState('Texture', 0)
          if (this.elementId) {
            const isShowRvtGroup = this.$refs.viewTree?.isShowRvtGroup
            if (isShowRvtGroup) {
              const rvtGroupInfo = await this.getRvtGroupInfo()
              const attributeData = await this.getRvtGroupAttr(rvtGroupInfo)
              this.attributeData = attributeData
            } else {
              this.queryElementAttr()
            }
          }
        } else {
          this.attributePanelVisible = false
        }
      }

      if (btnName.includes('Texture')) {
        if (btnStatus === 1) {
          this.texturePanelVisible = true
          this.attributePanelVisible = false
          window.BlackHole3D.Graphics.setBtnActiveState('Attribute', 0)
        } else {
          this.texturePanelVisible = false
        }
      }
    },
    openViewTreePanel() {
      this.viewTreePanelVisible = true
      window.BlackHole3D.Graphics.setBtnActiveState('Catalog_Tree', 1)
    },
    closeViewTreePanel() {
      this.viewTreePanelVisible = false
      window.BlackHole3D.Graphics.setBtnActiveState('Catalog_Tree', 0)
    },
    closeAttributePanel() {
      this.attributePanelVisible = false
      this.elementId = ''
      this.attributeData = []
      window.BlackHole3D.Graphics.setBtnActiveState('Attribute', 0)
    },
    closeTexturePanel() {
      this.texturePanelVisible = false
      window.BlackHole3D.Graphics.setBtnActiveState('Texture', 0)
    },
    openCadLayerPanel() {
      this.cadLayoutPanelVisible = false
      this.cadlayerPanelVisible = true
    },
    updateCadLayer() {
      let dom = this.$refs.cadLayer
      if (dom) {
        dom.initCadLayerList()
      }
    },
    closeCadLayerPanel() {
      this.cadlayerPanelVisible = false
    },
    openCadLayoutPanel() {
      this.cadlayerPanelVisible = false
      this.cadLayoutPanelVisible = true
    },
    updateCadLayout() {
      let dom = this.$refs.cadLayout
      if (dom) {
        dom.initCadLayoutList()
      }
    },
    closeCadLayoutPanel() {
      this.cadLayoutPanelVisible = false
    },
    loadBIMCAD(cadInfo) {
      this.rvtCadInfo = cadInfo
      this.$refs.engineDemo.loadBIMCAD(cadInfo, this.canvasViewMode)
    },
    setCanvasViewMode(canvasViewMode) {
      this.canvasViewMode = canvasViewMode
    },
    toggleCanvasViewMode() {
      if (this.canvasViewMode === 'bimCad') {
        this.viewTreePanelLimit = ''
        this.cadLayerPanelLimit = ''
        this.canvasViewMode = 'rvtCad'
        this.$refs.engineDemo.toggleCanvasViewMode('rvtCad')
      } else {
        this.viewTreePanelLimit = 'left'
        this.cadLayerPanelLimit = 'right'
        this.canvasViewMode = 'bimCad'
        this.$refs.engineDemo.toggleCanvasViewMode('bimCad')
      }
    },
    setVisibleElemAlpha() {
      let dataSetId = this.$route.params.resourceId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId

      let visibleElements = window.BlackHole3D.BIM.getDataSetAllElemIDs(
        resId,
        true
      )
      window.BlackHole3D.BIM.setElemAlpha(resId, visibleElements, 30)
    },
    showRoom(roomInfo) {
      let dataSetId = this.$route.params.resourceId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId
      if (!roomInfo.levelHeightTop) {
        // 重置所有构件颜色，防止切换房间时，上次选中的房间颜色依旧存在
        window.BlackHole3D.BIM.resetElemAttr(resId, [])
        this.setVisibleElemAlpha()

        this.$refs.engineDemo.showRoomByElemId(resId, roomInfo.elemIntIds)
      } else {
        let deltaHeight = roomInfo.levelHeightTop - roomInfo.levelHeightBottom
        deltaHeight = Number((deltaHeight * 0.6).toFixed(2))
        let bottomHeight = Number(Number(roomInfo.levelHeightBottom).toFixed(2))

        this.$refs.engineDemo.showRoom(
          resId,
          bottomHeight + deltaHeight,
          bottomHeight,
          roomInfo.elemIntIds
        )
      }
    },
    resetElemAttr() {
      let dataSetId = this.$route.params.resourceId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId
      window.BlackHole3D.BIM.resetElemAttr(resId, [])
    },
    highLightElement(childNodeIds, isRootnode) {
      let dataSetId = this.$route.params.resourceId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find ? find.resId : ''

      this.$refs.engineDemo.highLightElement(resId, childNodeIds, isRootnode)
    },
    hiddenDataset(dataType) {
      let dataSetId = this.$route.params.resourceId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find ? find.resId : ''

      this.$refs.engineDemo.hiddenDataset(dataType, resId)
    },
    showDataset(dataType, focusFlag) {
      let dataSetId = this.$route.params.resourceId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find ? find.resId : ''

      this.$refs.engineDemo.showDataset(dataType, resId, focusFlag)
    },
    hiddenElement(childNodeIds) {
      let dataSetId = this.$route.params.resourceId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find ? find.resId : ''

      this.$refs.engineDemo.hiddenElement(resId, childNodeIds)
    },
    showElement(childNodeIds) {
      let dataSetId = this.$route.params.resourceId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find ? find.resId : ''

      this.$refs.engineDemo.showElement(resId, childNodeIds)
    },
    deleteCustomBtn(uiID) {
      window.BlackHole3D.Graphics.delWidget(uiID)
    },
    getImgPath(iconName) {
      let { origin, pathname } = window.location
      let iconPath = `${origin}${pathname.split('/index.html')[0]}`
      return `${iconPath}/engineIcon/${iconName}`
    },
    copyCanvas() {
      const canvasBox = document.getElementById('engineCanvas')
      if (canvasBox) {
        const canvasContainer = document.getElementById('canvas-container')
        canvasContainer.append(canvasBox)
      }
    },
    /**
     * 记录分享被读取
     */
    recordShareRead() {
      let clientIp = window.location.host.split(':')[0]
      let resourceName = this.dataSetInfo.dataSetName
      let { shareId, resourceId } = this.$route.params
      let params = {
        clientIp,
        shareId,
        clientType: 0,
        resourceId: resourceId,
        resourceName
      }
      let token = this.$route.query.token
      let headers = { Authorization: token }
      shareRead(params, { headers }).then(response => {
        if (!response.isSuccess) {
          this.$message.error(response.errMsg)
        }
      })
    },
    getHeaders() {
      let token = this.$route.query.token
      let headers = {
        Authorization: token
      }
      return headers
    }
  }
}
</script>

<style lang="less" scoped>
.dataset-share-view-container {
  height: 100%;
  overflow: hidden;

  .header-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    line-height: 60px;
    padding-right: 20px;
    background: var(--header-bg-color);
    text-align: left;

    .dataset-name {
      margin-left: 20px;
      font-size: 20px;
      font-weight: 400;
    }
  }

  .content-box {
    position: relative;
    height: calc(100% - 60px);
    overflow: hidden;

    .catalog-tree-btn-box {
      position: absolute;
      top: 6px;
      left: 10px;
      width: 40px;
      height: 40px;
      background: var(--bimview-left-toolbtn-bgColor);
      cursor: pointer;
      border-radius: 10px;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;

      .icon {
        color: var(--bimview-toolbtn-text-color);
      }
    }

    .cad-toolbar-box {
      position: absolute;
      top: 6px;
      border-radius: 4px;
      padding: 0px 10px;
      z-index: 4;
      display: flex;
      align-items: center;

      .svg-box {
        background-color: var(--bimview-toolbtn-bgColor);
        border-radius: 10px;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:not(:last-child) {
          margin-right: 16px;
        }
      }

      .icon {
        cursor: pointer;
        color: var(--bimview-toolbtn-text-color);
      }
    }

    .left0 {
      left: 0;
    }

    .margin30 {
      margin-left: 56px;
    }

    .left50 {
      left: 50%;
    }
  }
}
</style>
